'use es6';

import { QUERY_PARAM_TERM_UPDATED } from 'pricing-pages-unified-ui/constants/ActionTypes';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { validateTermOrGetDefault } from 'pricing-pages-unified-ui/utils/validators';
const termFromQueryParam = getQueryParams().term;
const initialState = validateTermOrGetDefault(termFromQueryParam);

const QueryParamTerm = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case QUERY_PARAM_TERM_UPDATED:
      return payload;

    default:
      return state;
  }
};

export default QueryParamTerm;